<template>
	<tr>
		<td style="display:flex;">
			<b-select expanded v-model="activity_type" :disabled="!form.issued_to" style="width:50%;" placeholder="Activity Type">
                <option v-for="(type, key) in filteredActivityTypes">
                    {{ type.category }}
                </option>
            </b-select>
			<b-select expanded v-model="codeHandler" :disabled="!activity_type" style="width:50%;" placeholder="Service Code">
                <option :value="code" v-for="(code, key) in serviceCodes">
                    {{ code.ninaCode }} - {{ code.description }}
                </option>
            </b-select>
		</td>

		<td style="width:10%;">
			<b-input v-model="quantity"></b-input>
		</td>
		<td style="width:10%;">
			<b-input disabled readonly v-model="rate"></b-input>
		</td>
		<td style="width:10%;">
			<b-input disabled readonly :value="total | numberPriceFormatterWithDollarSign"></b-input>
		</td>
		<td style="width:10%;">
			<b-modal :active="modal" has-modal-card trap-focus aria-role="dialog" aria-modal>
				<div class="modal-card" style="min-width:500px;">
	                <header class="modal-card-head">
	                    <p class="modal-card-title">Claim Line Note</p>
	                </header>
	                <section class="modal-card-body">
				          <b-input type="textarea" v-model="notes"></b-input>
	                </section>
	                <footer class="modal-card-foot">
	                    <button class="button" style="position: absolute; left: 20px;" type="button" @click="notes = null, modal = false">Cancel</button>
	                    <button class="button is-info" type="button" @click="modal = false">Save</button>
	                </footer>
	            </div>
        	</b-modal>
        	<div>
				<b-button @click="modal = true">Notes</b-button>
        	</div>
		</td>
		<td  style="width:10%; text-align:right;">
			<b-button type="is-danger" @click="remove">
				<i class="fa fa-minus"></i>
			</b-button>
		</td>
	</tr>
</template>
<script>
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
export default {
	props: [ 'index', 'activityTypes', 'form' ],
    data: () => ({
    	modal: false,
		activity_type: null,
    	code: null,
		quantity: 1,
		rate: 0.00,
		notes: null,
		serviceCodes: [],
		codeHandler: null,
    }),
    computed: {
		total() {
			return this.quantity * this.rate;
		},
		filteredActivityTypes() {
			if (this.form.issued_to) {
				return this.activityTypes.filter(element => element.firmId == this.form.issued_to.child_id);
			}
			return [];
		},
    },
    watch: {
    	code(value) {
    		this.$emit('updateClaimData', {type: 'code', index: this.index, value: value});
    	},
    	quantity(value) {
    		this.$emit('updateClaimData', {type: 'quantity', index: this.index, value: value});
    	},
    	rate(value) {
    		this.$emit('updateClaimData', {type: 'rate', index: this.index, value: value});
    	},
    	total(value) {
    		this.$emit('updateClaimData', {type: 'total', index: this.index, value: value});
    	},
    	notes(value) {
    		this.$emit('updateClaimData', {type: 'notes', index: this.index, value: value});
    	},
		'activity_type'(value) {
			OrderOperationClaimServiceService.all({category: value}).then(response => {
				this.serviceCodes = JsonDenormalizer.denormalize(response);
			});
		},
		'codeHandler'(codeHandler) {
			this.code = codeHandler.id;
			this.rate = codeHandler.rate;
		},
    },
    methods: {
    	remove() {
    		this.$emit('removeClaim', this.index);
    	}
    }

};
</script>



// WEBPACK FOOTER //
// src/components/pages/Operations/claimLines.vue